"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[62],{

/***/ 56299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DestacadosProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77837);
/* harmony import */ var components_Environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63458);





function DestacadosProvider(props) {
    var ref = (0,components_Environment__WEBPACK_IMPORTED_MODULE_1__/* .useEnvironment */ .O7)(), current = ref.current, requests = ref.requests;
    var queryParams = function(url, enabled) {
        return [
            [
                url
            ],
            function() {
                return requests["2022"]({
                    method: "GET",
                    url: url
                });
            },
            {
                enabled: Boolean(enabled || current)
            }
        ];
    };
    var ref1 = _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery.apply */ .a.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(queryParams(current === null || current === void 0 ? void 0 : current.destacados))), destacados = ref1.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Environment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        env: {
            highlights: destacados === null || destacados === void 0 ? void 0 : destacados.highlights
        }
    }, props));
};


/***/ }),

/***/ 15623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Highlighted; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30719);
/* harmony import */ var components_2022_plebiscito_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31006);
/* harmony import */ var components_2022_plebiscito_TitleHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54761);
/* harmony import */ var components_Environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63458);
/* harmony import */ var components_global_parameters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29443);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_10__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-flow: column;\n    align-items: center;\n    padding: ",
        ";\n    .swiper {\n      width: 100%;\n      padding: 24px 0 36px 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











function Highlighted(param) {
    var className = param.className, _isSkeleton = param.isSkeleton, isSkeleton = _isSkeleton === void 0 ? false : _isSkeleton;
    var highlights = (0,components_Environment__WEBPACK_IMPORTED_MODULE_6__/* .useEnvironment */ .O7)().highlights;
    if (!highlights || !highlights.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleHeader, {
                isSkeleton: isSkeleton,
                children: "Destacados"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                breakpoints: {
                    1200: {
                        slidesPerView: 3
                    },
                    780: {
                        slidesPerView: 2
                    }
                },
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
                    swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_
                ],
                navigation: true,
                pagination: {
                    clickable: true
                },
                slidesPerView: 1,
                spaceBetween: 10,
                children: highlights.map(function(result, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_2022_plebiscito_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                            isSkeleton: isSkeleton
                        }, result))
                    }, index);
                })
            })
        ]
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ec3b50d-0"
})(_templateObject(), components_global_parameters__WEBPACK_IMPORTED_MODULE_7__/* .spaces.m */ .RZ.m);
var skeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* .css */ .iv)(_templateObject1());
var TitleHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(components_2022_plebiscito_TitleHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-2ec3b50d-1"
})(_templateObject2(), function(param) {
    var isSkeleton = param.isSkeleton;
    return isSkeleton && skeleton;
});


/***/ }),

/***/ 36062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Plebiscito; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./components/2022/Layout.js + 8 modules
var Layout = __webpack_require__(96418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 8 modules
var useQuery = __webpack_require__(77837);
// EXTERNAL MODULE: ./components/2022/plebiscito/contextData/territories.js
var territories = __webpack_require__(37269);
// EXTERNAL MODULE: ./components/2022/plebiscito/contextData/zonesMapping.js
var zonesMapping = __webpack_require__(28629);
// EXTERNAL MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/index.js + 3 modules
var CircleGraph = __webpack_require__(32384);
// EXTERNAL MODULE: ./components/2022/plebiscito/CountedTables/CircleGraph/CardInfo.js
var CardInfo = __webpack_require__(22331);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./components/2022/plebiscito/helpers.js
var helpers = __webpack_require__(25735);
// EXTERNAL MODULE: ./components/global-parameters.js
var global_parameters = __webpack_require__(29443);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/helpers.js




var labels = [
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00"
];
var initialScrutiny = [
    {
        countedTablesPercentage: 0,
        territories: [
            {
                ratio: 0,
                territoryId: "t.r.dearicayparinacota"
            },
            {
                ratio: 0,
                territoryId: "t.r.detarapaca"
            },
            {
                ratio: 0,
                territoryId: "t.r.deantofagasta"
            },
            {
                ratio: 0,
                territoryId: "t.r.deatacama"
            },
            {
                ratio: 0,
                territoryId: "t.r.decoquimbo"
            },
            {
                ratio: 0,
                territoryId: "t.r.devalparaiso"
            },
            {
                ratio: 0,
                territoryId: "t.r.metropolitanadesantiago"
            },
            {
                ratio: 0,
                territoryId: "t.r.dellibertadorgeneralbernardoohiggins"
            },
            {
                ratio: 0,
                territoryId: "t.r.delmaule"
            },
            {
                ratio: 0,
                territoryId: "t.r.denuble"
            },
            {
                ratio: 0,
                territoryId: "t.r.delbiobio"
            },
            {
                ratio: 0,
                territoryId: "t.r.delaaraucania"
            },
            {
                ratio: 0,
                territoryId: "t.r.delosrios"
            },
            {
                ratio: 0,
                territoryId: "t.r.deloslagos"
            },
            {
                ratio: 0,
                territoryId: "t.r.deaysendelgeneralcarlosibanezdelcampo"
            },
            {
                ratio: 0,
                territoryId: "t.r.demagallanesydelaantarticachilena"
            }, 
        ],
        timestamp: "2022-08-02T15:00:00"
    }
];
var formatTimestamp = function(param) {
    var timestamp = param.timestamp;
    var date = new Date(timestamp);
    var timeFormatter = new Intl.DateTimeFormat("es-ES", {
        hour: "numeric",
        hour12: false,
        minute: "numeric"
    });
    return timeFormatter.format(date);
};
var getTimelineData = function(param) {
    var popoverFactory = param.popoverFactory, ranges = param.ranges, scrutinies = param.scrutinies, territories = param.territories, zonesMapping = param.zonesMapping;
    if (!scrutinies) return [];
    var withTerritoryData = scrutinies.map(function(param) {
        var mesas_escrutadas_chile = param.mesas_escrutadas_chile, byTerritory = param.territories, total_mesas_chile = param.total_mesas_chile;
        var byRegion = lodash_default().groupBy(byTerritory, "cod_region");
        var ratioMesasEscrutadasChile = mesas_escrutadas_chile / total_mesas_chile;
        var withRatio = Object.entries(byRegion).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), regionCode = _param[0], regionScrutinies = _param[1];
            var totalMesas = lodash_default().sumBy(regionScrutinies, "total_mesas");
            var totalMesasEscrutadas = lodash_default().sumBy(regionScrutinies, "mesas_escrutadas");
            var ratioMesasEscrutadas = totalMesasEscrutadas / totalMesas;
            var territory = territories.find(function(t) {
                return String(t.cod_region) === String(regionCode);
            });
            return {
                order: zonesMapping.find(function(zone) {
                    return zone.key === territory.n_key_region;
                }).order,
                ratio: isNaN(ratioMesasEscrutadas) ? 0 : ratioMesasEscrutadas,
                territoryId: territory.n_key_region
            };
        }).sort(function(territoryRatioA, territoryRatioB) {
            return territoryRatioA.order - territoryRatioB.order;
        });
        return {
            countedTablesPercentage: isNaN(ratioMesasEscrutadasChile) ? 0 : ratioMesasEscrutadasChile,
            territories: withRatio.map(function(param) {
                var ratio = param.ratio, territoryId = param.territoryId;
                var ref = zonesMapping.find(function(t) {
                    return t.key === territoryId;
                }), acronym = ref.acronym, label = ref.label;
                return {
                    color: ranges.find(function(param) {
                        var range = param.range;
                        return (0,helpers/* between */.vX)(ratio, range);
                    }).color,
                    label: acronym,
                    onClick: function() {
                        return console.log(territoryId);
                    },
                    popover: popoverFactory && popoverFactory({
                        ratio: ratio,
                        shortLabel: label
                    }),
                    ratio: ratio,
                    shortLabel: label,
                    territoryId: territoryId
                };
            })
        };
    });
    var withLabels = labels.map(function(label, idx) {
        var territory = withTerritoryData[idx];
        if (territory) {
            territory.timeLabel = label;
            return territory;
        } else {
            return {
                timeLabel: label
            };
        }
    });
    return withLabels;
};
var getRanges = function() {
    return [
        {
            color: global_parameters/* colors.colorGrey13 */.O9.colorGrey13,
            label: "<10%",
            range: [
                0,
                0.1
            ]
        },
        {
            color: global_parameters/* colors.colorGrey15 */.O9.colorGrey15,
            label: "<50%",
            range: [
                0.1,
                0.5
            ]
        },
        {
            color: global_parameters/* colors.colorGrey14 */.O9.colorGrey14,
            label: "<80%",
            range: [
                0.5,
                0.8
            ]
        },
        {
            color: global_parameters/* colors.decidechileBlue */.O9.decidechileBlue,
            label: "80%+",
            range: [
                0.8,
                Infinity
            ]
        }, 
    ];
};

// EXTERNAL MODULE: ./components/2022/plebiscito/CountedTables/Timeline/index.js + 2 modules
var Timeline = __webpack_require__(48029);
// EXTERNAL MODULE: ./components/2022/plebiscito/TitleHeader.js
var TitleHeader = __webpack_require__(54761);
// EXTERNAL MODULE: ./components/Environment.js
var Environment = __webpack_require__(63458);
;// CONCATENATED MODULE: ./components/2022/plebiscito/CountedTables/index.js


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  align-items: center;\n  @media(max-width: ",
        "){\n    font-size: 9px;\n    max-width: 500px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    font-size: 3em;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media(max-width: ",
        "){\n    width: 338px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media(max-width: ",
        "){\n    display: contents;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var TRASVERSE_INTERVAL_TIME = 0.5;
function CountedTables(param) {
    var className = param.className;
    var ref;
    var ref1 = (0,Environment/* useEnvironment */.O7)(), current = ref1.current, requests = ref1.requests;
    var tables = Number(current.comunas.split("/").at(-1).split("_")[0]) / 10000;
    var queryParams = function(url, enabled) {
        return [
            [
                url
            ],
            function() {
                return requests["2022"]({
                    method: "GET",
                    url: url
                });
            },
            {
                enabled: Boolean(enabled || current)
            }
        ];
    };
    var ref2 = useQuery/* useQuery.apply */.a.apply(void 0, (0,_to_consumable_array/* default */.Z)(queryParams(current === null || current === void 0 ? void 0 : current.mesasescrutadas))), mesasEscrutadas = ref2.data;
    var baseScrutinies = mesasEscrutadas;
    var scrutinyDate = baseScrutinies && Date.parse((ref = baseScrutinies[0]) === null || ref === void 0 ? void 0 : ref.timestamp);
    var scrutinyTime = new Intl.DateTimeFormat("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "America/Toronto"
    }).format(scrutinyDate);
    var ranges = getRanges();
    var timelineData = getTimelineData({
        popoverFactory: function(param) {
            var ratio = param.ratio, shortLabel = param.shortLabel;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CountedTables_CardInfo, {
                label: shortLabel,
                percentage: ratio
            });
        },
        ranges: ranges,
        scrutinies: baseScrutinies,
        territories: territories/* default */.Z,
        zonesMapping: zonesMapping/* default */.ZP
    });
    var lastTimelineIndex = -1;
    timelineData.forEach(function(param, idx) {
        var timeLabel = param.timeLabel;
        if (timeLabel < scrutinyTime) {
            lastTimelineIndex = idx;
        }
    });
    var ref3 = (0,react.useState)(), selectedTimeIndex = ref3[0], setSelectedTimeIndex = ref3[1];
    var selectedTime = timelineData[selectedTimeIndex];
    var ref4 = (0,react.useState)(false), trasverseTimelineInterval = ref4[0], setTrasverseTimelineInterval = ref4[1];
    var startTrasverse = function() {
        var ref;
        var nextIndex = selectedTimeIndex + 1;
        var nextHasData = (ref = timelineData[nextIndex]) === null || ref === void 0 ? void 0 : ref.countedTablesPercentage;
        var trasverEnded = !nextHasData;
        if (trasverEnded) {
            setSelectedTimeIndex(0);
        }
        setTrasverseTimelineInterval(true);
    };
    (0,react.useEffect)(function() {
        var ref;
        if (selectedTimeIndex === undefined && mesasEscrutadas) setSelectedTimeIndex(mesasEscrutadas.length - 1);
        var nextIndex = selectedTimeIndex + 1;
        var nextHasData = (ref = timelineData[nextIndex]) === null || ref === void 0 ? void 0 : ref.countedTablesPercentage;
        var interval = trasverseTimelineInterval && nextHasData && setInterval(function() {
            return setSelectedTimeIndex(nextIndex);
        }, TRASVERSE_INTERVAL_TIME * 1000);
        return function() {
            if (trasverseTimelineInterval) {
                var ref;
                clearInterval(interval);
                var trasversingEnded = !((ref = timelineData[selectedTimeIndex]) === null || ref === void 0 ? void 0 : ref.countedTablesPercentage);
                if (trasversingEnded) {
                    setTrasverseTimelineInterval(false);
                }
            }
        };
    }, [
        selectedTimeIndex,
        timelineData,
        trasverseTimelineInterval,
        mesasEscrutadas
    ]);
    if (!timelineData) return "...loading";
    var lastMode = true;
    var format = global_parameters/* percentFormatter.format */.yE.format;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Percentage, {
                        children: format(tables)
                    }),
                    " de mesas escrutadas"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* default */.Z, {
                current: selectedTimeIndex,
                labels: timelineData.map(function(param) {
                    var timeLabel = param.timeLabel;
                    return timeLabel;
                }),
                lastLabelIdx: lastMode ? lastTimelineIndex : (baseScrutinies === null || baseScrutinies === void 0 ? void 0 : baseScrutinies.length) - 1,
                lastMode: lastMode,
                onChange: setSelectedTimeIndex,
                onPause: function() {
                    return setTrasverseTimelineInterval(false);
                },
                onPlay: function() {
                    return startTrasverse();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CirclesGraph, {
                circles: selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.territories,
                ranges: getRanges()
            })
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbb6b4ca-0"
})(_templateObject(), global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint);
var Title = (0,styled_components_browser_esm/* default */.ZP)(TitleHeader/* default */.ZP).withConfig({
    componentId: "sc-cbb6b4ca-1"
})(_templateObject1(), TitleHeader/* Title */.Dx);
var Percentage = styled_components_browser_esm/* default.b.withConfig */.ZP.b.withConfig({
    componentId: "sc-cbb6b4ca-2"
})(_templateObject2());
var CirclesGraph = (0,styled_components_browser_esm/* default */.ZP)(CircleGraph/* default */.Z).withConfig({
    componentId: "sc-cbb6b4ca-3"
})(_templateObject3(), global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint);
var CountedTables_CardInfo = (0,styled_components_browser_esm/* default */.ZP)(CardInfo/* default */.ZP).withConfig({
    componentId: "sc-cbb6b4ca-4"
})(_templateObject4(), global_parameters/* spaces.maxWidth */.RZ.maxWidth);

// EXTERNAL MODULE: ./components/2022/plebiscito/HorizontalSeparator.js
var HorizontalSeparator = __webpack_require__(63190);
// EXTERNAL MODULE: ./components/2022/plebiscito/[regionId]/Communes/RegionSection/helpers.js + 2 modules
var RegionSection_helpers = __webpack_require__(73122);
// EXTERNAL MODULE: ./components/2022/plebiscito/AtDecideChile.js
var AtDecideChile = __webpack_require__(67171);
// EXTERNAL MODULE: ./components/2022/plebiscito/RegionSection/helpers.js
var plebiscito_RegionSection_helpers = __webpack_require__(21660);
// EXTERNAL MODULE: ./components/2022/plebiscito/RegionSection/SearchFilter.js + 1 modules
var SearchFilter = __webpack_require__(14979);
// EXTERNAL MODULE: ./components/2022/plebiscito/RegionSection/RegionTable/index.js + 2 modules
var RegionTable = __webpack_require__(54955);
;// CONCATENATED MODULE: ./components/2022/plebiscito/RegionSection/index.js

function RegionSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: ",
        ";\n"
    ]);
    RegionSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RegionSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: ",
        ";\n"
    ]);
    RegionSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RegionSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n"
    ]);
    RegionSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RegionSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    RegionSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RegionSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-end;\n"
    ]);
    RegionSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}











function RegionSection() {
    var ref = (0,react.useState)(""), inputFilter = ref[0], setInputFilter = ref[1];
    var ref1 = (0,react.useState)("pEntrada"), comparedElection = ref1[0], setComparedElection = ref1[1];
    var ref2 = (0,react.useState)("porcentaje"), selectedUnit = ref2[0], setSelectedUnit = ref2[1];
    var ref3 = (0,react.useState)({
        field: "order",
        order: "asc"
    }), sorter = ref3[0], setSorter = ref3[1];
    var ref4 = (0,Environment/* useEnvironment */.O7)(), _electionsData = ref4.electionsData, pEntrada = _electionsData.pEntrada, pSalida = _electionsData.pSalida, sVuelta = _electionsData.sVuelta;
    var onChangeComparedElection = function(newComparedElection) {
        setComparedElection(comparedElection !== newComparedElection && newComparedElection);
    };
    var onChangeSelectedUnit = function() {
        setSelectedUnit(selectedUnit === "porcentaje" ? "cantidad" : "porcentaje");
    };
    var onChangeSorter = function(param) {
        var field = param.field;
        return (0,RegionSection_helpers/* sorterHandler */.r)({
            field: field,
            setSorter: setSorter,
            sorter: sorter
        });
    };
    var regionTableData = (0,plebiscito_RegionSection_helpers/* getTerritoryTableData */.$Z)({
        comparedElection: comparedElection,
        inputFilter: inputFilter,
        pEntrada: pEntrada,
        pSalida: pSalida,
        sVuelta: sVuelta,
        selectedUnit: selectedUnit,
        sorter: sorter
    });
    var zoneTableData = (0,plebiscito_RegionSection_helpers/* getTerritoryTableData */.$Z)({
        comparedElection: comparedElection,
        getTerritoryData: plebiscito_RegionSection_helpers/* getZoneData */.sy,
        inputFilter: inputFilter,
        pEntrada: pEntrada,
        pSalida: pSalida,
        sVuelta: sVuelta,
        selectedUnit: selectedUnit,
        sorter: sorter
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegionSection_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionSection_TitleHeader, {
                    children: "Resultados de votos por regi\xf3n"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Results, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionSection_SearchFilter, {
                        comparedElection: comparedElection,
                        electionOptions: plebiscito_RegionSection_helpers/* ELECTIONS_TO_COMPARE */.De,
                        inputFilter: inputFilter,
                        onChangeComparedElection: onChangeComparedElection,
                        onChangeInputFilter: setInputFilter,
                        onChangeSelectedUnit: onChangeSelectedUnit,
                        onChangeSorter: onChangeSorter,
                        selectedUnit: selectedUnit
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionSection_AtDecideChile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tables, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTable/* default */.Z, {
                                currentSort: sorter,
                                data: regionTableData,
                                onSort: onChangeSorter,
                                selectedUnit: selectedUnit,
                                territoryImage: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTable/* default */.Z, {
                                currentSort: sorter,
                                data: zoneTableData,
                                firstColumnLabel: "Zona",
                                onSort: onChangeSorter,
                                selectedUnit: selectedUnit,
                                territoryImage: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Tables = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-339a1960-0"
})(RegionSection_templateObject(), global_parameters/* spaces.l */.RZ.l);
var RegionSection_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-339a1960-1"
})(RegionSection_templateObject1(), global_parameters/* spaces.s */.RZ.s);
var Results = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-339a1960-2"
})(RegionSection_templateObject2());
var Top = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-339a1960-3"
})(RegionSection_templateObject3(), global_parameters/* spaces.xxs */.RZ.xxs);
var RegionSection_AtDecideChile = (0,styled_components_browser_esm/* default */.ZP)(AtDecideChile/* default */.Z).withConfig({
    componentId: "sc-339a1960-4"
})(RegionSection_templateObject4());
var RegionSection_TitleHeader = (0,styled_components_browser_esm/* default */.ZP)(TitleHeader/* default */.ZP).withConfig({
    componentId: "sc-339a1960-5"
})(_templateObject5());
var RegionSection_SearchFilter = (0,styled_components_browser_esm/* default */.ZP)(SearchFilter/* default */.Z).withConfig({
    componentId: "sc-339a1960-6"
})(_templateObject6());

// EXTERNAL MODULE: ./components/2022/plebiscito/Summary/index.js
var Summary = __webpack_require__(88848);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/2022/plebiscito/iframe/DestacadosProvider.jsx
var DestacadosProvider = __webpack_require__(56299);
// EXTERNAL MODULE: ./components/2022/plebiscito/iframe/Highlighted.jsx
var Highlighted = __webpack_require__(15623);
;// CONCATENATED MODULE: ./components/2022/plebiscito/index.js

function plebiscito_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1px;\n  @media(max-width: ",
        "){\n    font-size: 0.9px;\n  }\n"
    ]);
    plebiscito_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function plebiscito_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n"
    ]);
    plebiscito_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function plebiscito_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  gap: ",
        ";\n"
    ]);
    plebiscito_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












function Plebiscito() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(plebiscito_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Plebiscito de salida | Decidechile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "Resultados y estad\xedsticas de las elecciones en tiempo real.",
                        name: "description"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalSeparator/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CountedTables, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalSeparator/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalSeparator/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DestacadosProvider/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(plebiscito_Highlighted, {})
                })
            })
        ]
    });
};
var plebiscito_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Layout/* default */.Z).withConfig({
    componentId: "sc-4272768-0"
})(plebiscito_templateObject(), global_parameters/* spaces.tabletBreakpoint */.RZ.tabletBreakpoint);
var HighlightedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4272768-1"
})(plebiscito_templateObject1());
var plebiscito_Highlighted = (0,styled_components_browser_esm/* default */.ZP)(Highlighted/* default */.Z).withConfig({
    componentId: "sc-4272768-2"
})(plebiscito_templateObject2(), global_parameters/* spaces.m */.RZ.m);


/***/ })

}]);